import { TimeInput } from '../inputs/TimeInput';
import createField from './createField';

const TimeField = createField(TimeInput);

export default TimeField;
